import React from "react";

export default props =>
    <footer className="conteiner-fluid row d-flex justify-content-center align-items-center" style={{background: "#292C36", height: "20vh"}}>
        <section className="col-10 d-flex flex-column justify-content-center align-items-center">
            <h1>CH</h1>
            <p>2022 carlos henrique </p>
        </section>  
    </footer>    